import React from 'react';
import { observer } from 'owa-mobx-react';
import { initializeIconColorMap, type IconColorMap } from '../../util/getRibbonIconColor';
import { useAppTheme } from './useAppTheme';

/**
 * Encapsulates all theme-related logic for Ribbon, including:
 * - Icon color mapping
 * - Fluent UI theme
 * - Next Style and Fluent v9 feature flag integration
 * - Theme initialization
 */
export const RibbonTheme: React.FC<{
    children: React.ReactNode;
    iconColorMap: IconColorMap;
}> = observer(({ children, iconColorMap }) => {
    // Initial rendering will occur when the ribbon definitions are created, so we
    // need to initialize the icon color map first.
    initializeIconColorMap(iconColorMap);

    useAppTheme();

    return <>{children}</>;
}, 'RibbonTheme');
